// Mirrors db schema/feed.ts enums but lives in shared so the FE can
// validate without depending on the db package. YouTube was previously a
// type here; it moved to its own /videos domain (youtube_playlists /
// youtube_videos tables).
export const FEED_TYPE_CODES = ['rss', 'atom'] as const;
export type FeedTypeCode = (typeof FEED_TYPE_CODES)[number];

export const FEED_ITEM_STATUS_CODES = ['new', 'skipped', 'imported'] as const;
export type FeedItemStatusCode = (typeof FEED_ITEM_STATUS_CODES)[number];

export interface FeedSourceListItem {
  id: string;
  name: string;
  url: string;
  type: FeedTypeCode;
  isActive: boolean;
  fetchIntervalMinutes: number;
  description: string | null;
  lastPolledAt: string | null;
  lastStatus: number | null;
  lastError: string | null;
  /** Count of pending feed_items.status='new' for this source. */
  pendingItemCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface FeedSourceDetail extends FeedSourceListItem {
  /** Last-seen HTTP cache hints. Internal-ish but useful when debugging. */
  lastEtag: string | null;
  lastModified: string | null;
}

export interface FeedItemRecord {
  id: string;
  sourceId: string;
  guid: string;
  title: string;
  link: string | null;
  summary: string | null;
  contentHtml: string | null;
  author: string | null;
  publishedAt: string | null;
  fetchedAt: string;
  status: FeedItemStatusCode;
  importedPostId: string | null;
  thumbnailUrl: string | null;
  imageUrl: string | null;
}
